/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type GroupingLevel = (typeof GroupingLevel)[keyof typeof GroupingLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GroupingLevel = {
  Day: 1,
  Week: 2,
  Month: 3,
  Year: 4,
} as const;
